import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { init, browserTracingIntegration } from '@sentry/react'
import { filterUnhandledApiRejection, handleUnhandledApiRejection } from './sentryErrorHandling'
import { getRouter } from './router'

window.addEventListener('unhandledrejection', handleUnhandledApiRejection)

const isProductionDeployment =
  window.location.hostname === 'terros.com' || window.location.hostname.endsWith('.terros.com')

init({
  enabled: isProductionDeployment,
  dsn: 'https://f996e1a65e116e83f078c223ebf42ea7@o4504577176305664.ingest.us.sentry.io/4508854584934400',
  tracesSampleRate: 0.5,
  beforeSend: filterUnhandledApiRejection,
  integrations: [browserTracingIntegration()],
})

const router = getRouter()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
